import { render, staticRenderFns } from "./MaintenanceStatusText.vue?vue&type=template&id=4c08f209&"
import script from "./MaintenanceStatusText.vue?vue&type=script&lang=js&"
export * from "./MaintenanceStatusText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports